import './App.css';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { WeekGrid } from './components/WeekGrid';
import { theme } from './theme/theme';
import { Header } from './components/Header/Header';

function App() {
	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<div className="App">
				<Header />
				<WeekGrid />
			</div>
		</ThemeProvider>
	);
}

export default App;
